import React, { useState, useEffect } from "react";

import Details from "./help/Details";
import Form from "./help/Form";
import List from "./help/List";

import { useLocalStorage } from 'utils/storage';

import { fetchCharts, createChart, updateChart, deleteChart } from "services/charts";

const Charts = ({
    setShowContent
}) => {
    const [currentState, setCurrentState] = useState('list');
    const [charts, setCharts] = useLocalStorage('charts', []);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        fetchCharts().then((data) => {
            if (data) {
                setCharts(data);
            }
        });
    }, []);

    const handleFormSubmit = async (form) => {
        let response;

        if (form.uid) {
            response = await updateChart(form);
        } else {
            response = await createChart(form);
        } 

        if(response){
            const itemInResponse = response.data.data;

            setCharts((currentItems) => {
                const isEditing = currentItems.some(n => n.uid === itemInResponse.uid);

                if (isEditing) {
                    return currentItems.map(item =>
                        item.uid === itemInResponse.uid ? itemInResponse : item
                    );
                } else {
                    return [...currentItems, itemInResponse];
                }
            });

            setCurrentState('list');
        }
    };

    const handleDelete = async (uid) => {
        if(await deleteChart(uid)){
            setCharts((charts) => charts.filter(n => n.uid !== uid));
        }
    };

    const handleOpenDetails = (item) => {
        setSelectedItem(item);
        setCurrentState('details');
    }
    
    const handleEdit = (item) => {
        setSelectedItem(item);
        setCurrentState('edit');
    };

    const handleClose = () => {
        setSelectedItem(null);
        setCurrentState('list');
    }

    const handleBackButton = () => {
        setShowContent(false);
    }

    const renderCurrentView = () => {
        switch (currentState) {
            case "list":
                return (
                    <List
                        items={charts}
                        onClickHandler={handleOpenDetails}
                        onDeleteHandler={handleDelete}
                        onEditHandler={handleEdit}
                        onBackClick={handleBackButton}
                        setCurrentState={setCurrentState}
                    />
                );
            case "details":
                return (
                    <Details
                        item={selectedItem}
                        onEditHandler={handleEdit}
                        onDeleteHandler={handleDelete}
                        onCloseHandler={handleClose}
                    />
                );
            case "add":
            case "edit":
                return (
                    <Form
                        itemToEdit={selectedItem}
                        onFormSubmit={handleFormSubmit}
                        onCancelHandler={handleClose}
                    />
                );
            default:
                return <div>Unknown state</div>;
        }
    };

    return (
        renderCurrentView()
    );
};

export default Charts;
